import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { useMilestone, useRecordMilestoneByDay } from "@faire/retailer-visitor-shared/stores/domain/useMilestone";
import { useEffect, useState, useCallback } from "react";
export var useSilenceWithMilestone = function(milestone, maxViewCount, delayMilestoneIncrement) {
    var _useState = _sliced_to_array(useState(true), 2), isSilenced = _useState[0], setIsSilenced = _useState[1];
    var count = useMilestone(milestone).count;
    var recordMilestoneByDay = useRecordMilestoneByDay();
    useEffect(function() {
        if (count <= maxViewCount) {
            setIsSilenced(false);
            if (!delayMilestoneIncrement) {
                recordMilestoneByDay(milestone);
            }
        }
    }, [
        count,
        delayMilestoneIncrement,
        maxViewCount,
        milestone,
        recordMilestoneByDay
    ]);
    var updateMilestoneOnView = useCallback(function() {
        if (count <= maxViewCount) {
            recordMilestoneByDay(milestone);
        }
    }, [
        count,
        maxViewCount,
        milestone,
        recordMilestoneByDay
    ]);
    return {
        isSilenced: isSilenced,
        updateMilestoneOnView: updateMilestoneOnView
    };
};
